<div class="form-group">
  <div class="row align-items-center">
    <div class="col-lg d-flex">
      <h3 class="h5 fw-normal">Email</h3>
      <span class="d-md-none">
        <i class="add-circle-icon ms-1 text-primary" (click)="enableAddEmail()"></i>
      </span>
    </div>
    <div class="col-lg text-end d-none d-md-block">
      <div>
        <button class="btn btn-primary" (click)="enableAddEmail()">Add</button>
      </div>
    </div>
  </div>
  <ul class="list-group mt-3">
    @if (!dataLoaded()) {
      <li class="list-group-item">
        <!-- //NOSONAR -->
        <ngx-skeleton-loader count="1" [theme]="{ height: '5rem' }"></ngx-skeleton-loader>
      </li>
    } @else if (!addEmailMode() && dataLoaded()) {
      @if (emails().length === 0) {
        <li class="list-group-item">
          <!-- //NOSONAR -->
          <p class="h6 fw-normal m-1 py-3">There are no email addresses on file for this educator</p>
        </li>
      }
      @for (email of emails(); track email.personEmailId) {
        <li class="list-group-item clickable" (click)="loadEditForm(email)" [ngClass]="emailItemClasses(email)">
          <!-- //NOSONAR -->
          @if (email) {
            <div class="d-flex justify-content-between my-1">
              <div>
                <span class="h6 fw-normal me-2">{{ email.email }}</span
                ><span class="badge-md badge-info">{{ email.description }}</span>
              </div>
              @if (email.personEmailId != selectedEmail()?.personEmailId) {
                <div>
                  <i certTooltip="Edit" class="edit-icon-lg"></i>
                </div>
              }
            </div>
          }
        </li>
      }
    } @else if (addEmailMode() && dataLoaded()) {
      <li class="list-group-item">
        <!-- //NOSONAR -->
        <edportal-educator-contact-email-form
          [email]="selectedEmail()"
          [emailOptions]="emailOptions()"
          (emailChanged)="handleFormEvent($event)"
        ></edportal-educator-contact-email-form>
      </li>
    }
  </ul>
</div>
